import { Controller } from "@hotwired/stimulus"

// Copia di un link mostrato una volta sola (InviteLinkBox.js, LinkRecuperoBox di AzioniAccesso.js).
export default class extends Controller {
  static targets = ["input", "iconaCopia", "iconaCopiato", "etichetta"]

  seleziona(event) {
    event.target.select()
  }

  async copia() {
    try {
      await navigator.clipboard.writeText(this.inputTarget.value)
      this.iconaCopiaTarget.setAttribute("hidden", "")
      this.iconaCopiatoTarget.removeAttribute("hidden")
      this.etichettaTarget.textContent = "Copiato"
      window.toast?.success("Link copiato")
    } catch {
      window.toast?.error("Copia non riuscita: seleziona il link e copialo a mano")
    }
  }

  // Il contenitore del riquadro (data-link-contenitore) si nasconde: vuoto non lascia spazio tra le sezioni.
  chiudi() {
    const contenitore = this.element.closest("[data-link-contenitore]")
    this.element.remove()
    if (contenitore) contenitore.hidden = true
  }
}
